<template>
  <div class="card mb-4">
    <div class="flex flex-col py-6 px-2 sm:px-4 text-center items-center">
      <h2 class="text-gray-700 mb-2 text-lg sm:text-xl">
        {{ $t('PersonalGoalsComponent.noGoalsHeading', { text: featureNamePersonalGoals }) }}
      </h2>
      <p class="text-gray-500 mb-4 text-sm sm:text-base">
        {{ $t('PersonalGoalsComponent.noGoalsText', { text: featureNamePersonalGoals }) }}
      </p>
      <Button @click.prevent="openCreateChoicePopup" type="button" id="newGoalsButton"
        class="btn-primary-accent w-48 py-2.5 px-5 text-base sm:text-lg" unstyled>
        {{ $t('PersonalGoalsComponent.newGoalButton') }}
      </Button>
    </div>
  </div>
</template>
<script>
import { Button } from 'primevue';
import { getFeatureDisplayNameOrFallback } from '@/utils/featureDisplay';

export default {
  name: 'NoPersonalGoalsComponent',
  components: { Button },
  computed: {
    featureNamePersonalGoals() {
      return getFeatureDisplayNameOrFallback(
        this.$store,
        'personalGoals',
        this.$t('FallbackTexts.personalGoals'),
        this.$i18n?.locale,
      );
    },
  },
  methods: {
    async openCreateChoicePopup() {
      // Prevent multiple taskCreator overlays from being created
      const existingOverlays = this.$store.getters.getFrontendOverlays;
      const hasTaskCreatorOverlay = existingOverlays.some((overlay) => overlay.type === 'taskCreator');
      if (hasTaskCreatorOverlay) {
        return;
      }

      window.scrollTo(0, 0);
      await this.$store.commit('setSelectedCreateTab', 'personalGoals');
      this.$store.commit('addFrontendOverlay', {
        id: Math.random(),
        type: 'taskCreator',
      });
    },
  },
};
</script>
